import React from 'react';
import {
    TextField,
    SimpleForm,
    Edit,
    Datagrid,
    Toolbar,
    SaveButton,
} from 'react-admin';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { SwList } from '../lib/SwList';
import { EditButton } from '../lib/wrappers/actions';
import { TextInput } from '../lib/wrappers/Inputs';
import { useAzureADGroups } from '../msal/useAzureADGroups';

export const InclusiveStatementLabels = {
    Title: 'Inclusive Curriculum Statement',
};

const ToolbarWithoutDelete = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
);

export const InclusiveCurriculumList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList {...props} bulkActionButtons={false}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="inclusiveCurriculumStatement" />
                    <EditButton />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const InclusiveCurriculumEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} redirect="show">
                <SimpleForm toolbar={<ToolbarWithoutDelete />}>
                    <TextInput source="inclusiveCurriculumStatement" />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};
